import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "axios";
import { clearCart } from "../../Features/Cart/cartSlice";
import * as backendModule from "../../modules/backendModule";
import Spinner from "../Spinner";
import success from "../../Assets/success.png";

const PaymentResult = ({ cancelled = false }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const orderNumber = new URLSearchParams(location.search).get("orderNumber");
  const [status, setStatus] = React.useState(cancelled ? "cancelled" : "pending");
  const [orderID, setOrderID] = React.useState(null);
  const [totalPrice, setTotalPrice] = React.useState(null);

  const currentDate = new Date();

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  React.useEffect(() => {
    if (cancelled || !orderNumber) {
      if (!orderNumber) setStatus("error");
      return undefined;
    }

    let attempts = 0;
    let timer;
    const checkStatus = async () => {
      attempts += 1;
      try {
        const response = await axios.post(
          `${backendModule.backendURL}/orders/monri/status`,
          { orderNumber },
          backendModule.axiosConfig
        );
        const result = response.data.data;
        setOrderID(result.orderID);
        setStatus(result.paymentStatus);
        setTotalPrice(result.totalPrice);
        if (result.paymentStatus === "paid") {
          dispatch(clearCart());
          return;
        }
        if (attempts >= 10) {
          setStatus("error");
          return;
        }
      } catch {
        if (attempts >= 10) setStatus("error");
      }
      if (attempts < 10) timer = window.setTimeout(checkStatus, 1500);
    };

    checkStatus();
    return () => window.clearTimeout(timer);
  }, [cancelled, dispatch, orderNumber]);

  return (
    <div className="shoppingCartSection" style={{ minHeight: "50vh", textAlign: "center" }}>
      {status === "pending" && <><Spinner /><h3>Potvrđujemo kartično plaćanje...</h3></>}
      {status === "paid" && <div className="shoppingCartTabsContainer" >
        <div className='shoppingCartTabs cartTab3'>
          <button
            className=""
          >
            <div className="shoppingCartTabsNumber">
              <h3>01</h3>
              <div className="shoppingCartTabsHeading">
                <h3>Korpa</h3>
                <p>Upravljaj svojim artiklima</p>
              </div>
            </div>
          </button>
          <button
            className=""
          >
            <div className="shoppingCartTabsNumber">
              <h3>02</h3>
              <div className="shoppingCartTabsHeading">
                <h3>Dostava i plaćanje</h3>
                <p>Plati svoje artikle</p>
              </div>
            </div>
          </button>
          <button
            className="active"
          >
            <div className="shoppingCartTabsNumber">
              <h3>03</h3>
              <div className="shoppingCartTabsHeading">
                <h3>Potvrda</h3>
                <p>Pregledaj i potvrdi svoju narudžbu</p>
              </div>
            </div>
          </button>
        </div>

        <div className="shoppingCartTabsContent">
          <div className="orderCompleteSection">
            <div className="orderComplete">
              <div className="orderCompleteMessage">
                <div className="orderCompleteMessageImg">
                  <img src={success} alt="" />
                </div>
                <h3>Plaćanje je izvršeno</h3>
                <p>Hvala vam! Vaša narudžba je zaprimljena. Očekujte dostavu u roku od 24 do 48 sati.</p>
              </div>
              <div className="orderInfo">
                <div className="orderInfoItem">
                  <p>Broj narudžbe</p>
                  <h4>{orderID}</h4>
                </div>
                <div className="orderInfoItem">
                  <p>Datum</p>
                  <h4>{formatDate(currentDate)}</h4>
                </div>
                <div className="orderInfoItem">
                  <p>Ukupno</p>
                  <h4>{Number(totalPrice).toFixed(2)} KM</h4>
                </div>
                <div className="orderInfoItem">
                  <p>Način plaćanja</p>
                  <h4>Kartično plaćeno</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>}
      {status === "cancelled" && <><h2>Plaćanje je otkazano</h2><p>Vaša kartica nije terećena. Sadržaj korpe je sačuvan.</p></>}
      {status === "error" && <><h2>Nismo mogli potvrditi plaćanje</h2><p>Ako ste završili plaćanje, kontaktirajte podršku prije ponovnog pokušaja.</p></>}
    </div>
  );
};

export default PaymentResult;
